import {ready} from '../main/utils';
import loadTechnicalDownloads from './technical-downloads';
import loadLiterature from './literature';
import loadMaintenanceRepairGuides from '../downloads/maintenance-repair-guides';

ready(() => {
  loadTechnicalDownloads();
  loadLiterature();
  loadMaintenanceRepairGuides();
});
